import permissions from '../permission-list'

export default [
  {
    path: '/v2/administrators',
    name: 'administrators-v2',
    component: () => import('@/views/v2/Administrators.vue'),
    meta: {
      pageTitle: 'Administrator',
      resource: permissions.administratorV2,
      action: 'read',
      navActiveLink: 'administrators-v2',
      breadcrumb: [
        { text: 'Administrator', active: true },
      ],
    },
  },
  {
    path: '/v2/administrators/create',
    name: 'administrators-v2-create',
    component: () => import('@/views/v2/AdministratorCreate.vue'),
    meta: {
      pageTitle: 'Tambah Administrator',
      resource: permissions.administratorV2,
      action: 'write',
      navActiveLink: 'administrators-v2',
      breadcrumb: [
        { text: 'Administrator', to: { name: 'administrators-v2' } },
        { text: 'Tambah', active: true },
      ],
    },
  },
  {
    path: '/v2/administrators/:id/edit',
    name: 'administrators-v2-edit',
    component: () => import('@/views/v2/AdministratorEdit.vue'),
    meta: {
      pageTitle: 'Ubah Administrator',
      resource: permissions.administratorV2,
      action: 'write',
      navActiveLink: 'administrators-v2',
      breadcrumb: [
        { text: 'Administrator', to: { name: 'administrators-v2' } },
        { text: 'Ubah', active: true },
      ],
    },
  },
  {
    path: '/v2/administrators/:id/detail',
    name: 'administrators-v2-detail',
    component: () => import('@/views/v2/AdministratorDetail.vue'),
    meta: {
      pageTitle: 'Detail Administrator',
      resource: permissions.administratorV2,
      action: 'read',
      navActiveLink: 'administrators-v2',
      breadcrumb: [
        { text: 'Administrator', to: { name: 'administrators-v2' } },
        { text: 'Detail', active: true },
      ],
    },
  },
]
